import { render, staticRenderFns } from "./GroupChatMembersMenu.vue?vue&type=template&id=76e47c91&scoped=true&"
import script from "./GroupChatMembersMenu.vue?vue&type=script&lang=js&"
export * from "./GroupChatMembersMenu.vue?vue&type=script&lang=js&"
import style0 from "./GroupChatMembersMenu.vue?vue&type=style&index=0&id=76e47c91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e47c91",
  null
  
)

export default component.exports